<button 
    class="w-full flex items-center justify-center gap-2 px-6 py-3 border-2 border-gray-200 dark:border-gray-700 rounded-xl font-semibold text-gray-700 dark:text-gray-300 hover:border-primary-500 hover:text-primary-600 dark:hover:text-primary-400 transition-all duration-200" 
    type="button" 
    (click)="loginWithGoogle()"
    [disabled]="isLoading"
    [class.opacity-70]="isLoading"
    [class.cursor-not-allowed]="isLoading">
    @if (isLoading) {
        <div class="w-5 h-5 border-2 border-gray-300 border-t-primary-600 rounded-full animate-spin"></div>
        <span>Łączenie z Google...</span>
    } @else {
        <img src="assets/images/others/g-logo.png" alt="Google" class="h-5 w-5">
        <span>Zaloguj się przez Google</span>
    }
</button>
